module.exports = __webpack_public_path__ + "30e2f7e2a4a85fe8110b16bd94cbf8b8.svg";